import {
  CompensationMethod,
  ReturnTypeEnum,
} from "@redotech/redo-model/return";
import { z } from "zod";

export enum GetReturnsByOrderIdErrors {
  UNAUTHORIZED = "UNAUTHORIZED",
  INVALID_ORDER_ID = "INVALID_ORDER_ID",
  INTERNAL_ERROR = "INTERNAL_ERROR",
}

const ReturnProductSchema = z.object({
  _id: z.string(),
  images: z.array(z.string().nullable()),
  status: z.string(),
  quantity: z.number(),
  strategy: z.string(),
  price: z.string(),
  variant_title: z.string(),
  product_title: z.string(),
  line_item_id: z.string(),
  rejectMessage: z.string().nullish(),
});
export const ReturnProduct: z.ZodType<ReturnProduct> = ReturnProductSchema;
export interface ReturnProduct extends z.infer<typeof ReturnProductSchema> {}

// Create a DisplayReturn schema that only includes fields needed for the returns UI
const DisplayReturnSchema = z.object({
  _id: z.string(),
  createdAt: z.union([z.string(), z.date()]),
  updatedAt: z.union([z.string(), z.date()]),
  status: z.string(),
  type: z.enum([
    ReturnTypeEnum.RETURN,
    ReturnTypeEnum.CLAIM,
    ReturnTypeEnum.WARRANTY,
    ReturnTypeEnum.MANAGED_CLAIM,
  ]),
  returnType: z.enum([
    CompensationMethod.REFUND,
    CompensationMethod.EXCHANGE,
    CompensationMethod.STORE_CREDIT,
  ]),
  products: z.array(ReturnProductSchema),
  draftOrderURL: z.string().optional(),
  labelDeductedFromCredit: z.boolean().nullish(),
  isManualLabel: z.boolean().nullish(),
});
export const DisplayReturn: z.ZodType<DisplayReturn> = DisplayReturnSchema;
export interface DisplayReturn extends z.infer<typeof DisplayReturnSchema> {}

export const getReturnsByOrderId = {
  input: z.object({ orderId: z.string() }),
  output: z.object({ returns: z.array(DisplayReturnSchema) }),
};
